import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import Search from './Search';

class Header extends Component {

  state = {
    redirect: false
  }
  
  onLinkClick = e => {
    e.preventDefault();
    this.setState({
      redirect: e.target.href
    });
  }
  
  render() {
    const menu = this.props.menu;

    return (
      <header className="page-header">
        <section className="header__top">
          <div className="container">
        
            <Link className="logo logo_header" to="/">
              <img src="/assets/imgs/logo.svg" alt="ICORE TAC"/>
            </Link>

            <nav>
              <ul>
                { menu.map( (v,i) => 
                  <li key={i}>
                    <Link to={ '/'+v.uri.replace(/^\/+/, '') }>{ v.menutitle ? v.menutitle : v.pagetitle }</Link>
                  </li>
                )}
              </ul>
            </nav>

            <Button class="header__callback" theme="success">Связаться</Button>

            <Button class="search__togglebtn">
              <i className="ico ico_search"></i>
            </Button>
          </div>
        </section>

        <Search/>
      </header>
    );
  }
}
export default Header;